import {Component, OnInit} from '@angular/core';
import {PartnerschaftsAngaben, PersonenstandEnumLabels} from '@nachdigal';
import {WizardPageBaseComponent} from '@utils-lib';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'common-ui-partnerschafts-angaben',
    templateUrl: './partnerschafts-angaben.component.html'
})
export class PartnerschaftsAngabenComponent extends WizardPageBaseComponent<PartnerschaftsAngaben> implements OnInit {

    static nutzdatenPath = 'partnerschaftsAngaben';
    static route = 'partnerschafts-angaben';
    public showEhepartnerAdressAngaben: boolean;
    private internalShowEhepartnerAngaben = false;

    constructor(protected readonly activatedRoute: ActivatedRoute) {
        super(activatedRoute);
    }

    public get canToggleEhepartnerAngaben(): boolean {

        if (!this.data.personenstand || !this.data.personenstand.personenstand) {
            return false;
        }

        // Der Toggle kann nur benutzt werden, wenn der Personenstand nicht
        // verheiratet (002) bzw. dauerhaft getrennt lebend (003) ist
        return this.data.personenstand.personenstand !== PersonenstandEnumLabels._002
            && this.data.personenstand.personenstand !== PersonenstandEnumLabels._003;
    }

    public get showEhepartnerAngaben(): boolean {
        if (!this.data.personenstand || !this.data.personenstand.personenstand) {
            this.data.ehepartner = null;
            this.data.ehepartnerInlandsadresse = null;
            this.data.ehepartnerAuslandsadresse = null;
            this.data.ehepartnerSteueridentifikation = null;
            return false;
        }
        return !this.canToggleEhepartnerAngaben || this.internalShowEhepartnerAngaben;
    }

    public set showEhepartnerAngaben(value: boolean) {
        this.internalShowEhepartnerAngaben = value;
    }

    public ngOnInit(): void {
        super.ngOnInit();

        this.showEhepartnerAngaben = !!this.data.ehepartner;
        this.showEhepartnerAdressAngaben = !!this.data.ehepartnerInlandsadresse || !!this.data.ehepartnerAuslandsadresse;
    }

    public onPartnerschaftPicked(): void {
        this.data.ehepartner = this.stammdaten?.partnerschaft?.partner?.ehepartner;
        this.data.personenstand = this.stammdaten?.partnerschaft?.partner?.personenstand;
        this.data.ehepartnerSteueridentifikation = this.stammdaten?.partnerschaft?.partner?.steueridentifikation;

        this.showEhepartnerAngaben = !!this.data.ehepartner;
    }

    public clearAddresses($event: boolean): void {
        if (!$event) {
            this.data.ehepartnerInlandsadresse = null;
            this.data.ehepartnerAuslandsadresse = null;
        }
    }

    protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
        return new Map<string, unknown | Array<unknown>>([
            ['personenstand', this.stammdaten?.partnerschaft?.partner?.personenstand],
            ['ehepartner', this.stammdaten?.partnerschaft?.partner?.ehepartner],
            ['ehepartnerSteueridentifikation', this.stammdaten?.partnerschaft?.partner?.steueridentifikation],
            ['ehepartnerInlandsadresse', this.stammdaten?.partnerschaft?.ehepartnerInlandsadressen],
            ['ehepartnerAuslandsadresse', this.stammdaten?.partnerschaft?.ehepartnerAuslandsadressen]
        ]);
    }
}
